"use strict";
'kiwi public';
/** @module */

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");

var _Reflect$construct = require("@babel/runtime-corejs3/core-js-stable/reflect/construct");

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/getPrototypeOf"));

var _eventemitter = _interopRequireDefault(require("eventemitter3"));

var _vue = _interopRequireDefault(require("vue"));

var _json = _interopRequireDefault(require("json5"));

var _lodash = _interopRequireDefault(require("lodash"));

var _compareVersions = _interopRequireDefault(require("compare-versions"));

var Misc = _interopRequireWildcard(require("@/helpers/Misc"));

var _Logger = _interopRequireDefault(require("./Logger"));

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var singletonInstance = null;
var pluginsToInit = [];
var nextPluginId = 0;
/** The global kiwi API instance */

var GlobalApi = /*#__PURE__*/function (_EventEmitter) {
  (0, _inherits2.default)(GlobalApi, _EventEmitter);

  var _super = _createSuper(GlobalApi);

  function GlobalApi() {
    var _this;

    (0, _classCallCheck2.default)(this, GlobalApi);
    _this = _super.call(this); // Version information from DefinePlugin in vue.config.js

    _this.version = __VERSION__; // eslint-disable-line no-undef

    _this.commithash = __COMMITHASH__; // eslint-disable-line no-undef

    /** A reference to the internal Vuejs instance */

    _this.Vue = _vue.default;
    /** Expose JSON5 so that plugins can use the same config format */

    _this.JSON5 = _json.default;
    /** The applications internal state */

    _this.state = null;
    /** The applications ThemeManager */

    _this.themes = null;
    _this.controlInputPlugins = [];
    _this.stateBrowserPlugins = [];
    _this.channelHeaderPlugins = [];
    _this.queryHeaderPlugins = [];
    _this.sideBarPlugins = [];
    _this.userboxButtonPlugins = [];
    _this.appSettingsPlugins = [];
    _this.serverViewPlugins = [];
    _this.aboutBufferPlugins = [];
    _this.tabs = Object.create(null);
    _this.isReady = false;
    /* eslint-disable no-underscore-dangle */

    _this.exports = window._kiwi_exports || {};

    _this.on('init', function () {
      _this.isReady = true;

      _this.initPlugins();
    });

    return _this;
  }

  (0, _createClass2.default)(GlobalApi, [{
    key: "versionMatches",
    value: function versionMatches(v) {
      return (0, _compareVersions.default)(this.version, v) >= 0;
    }
    /**
     * Register a plugin with kiwi
     *
     * Plugins being loaded at startup will be registered once Kiwi is ready. At any
     * other point the plugin will be registered instantly
     * @param {String} pluginName The name of this plugin
     * @param {Function} fn A callback function to start the plugin. function(kiwi, logger)
     */

  }, {
    key: "plugin",
    value: function plugin(pluginName, fn) {
      var plugin = {
        name: pluginName,
        fn: fn
      };

      if (this.isReady) {
        this.initPlugin(plugin);
      } else {
        pluginsToInit.push(plugin);
      }
    } // Init any plugins that were added before we were ready

  }, {
    key: "initPlugins",
    value: function initPlugins() {
      var _this2 = this;

      pluginsToInit.forEach(function (plugin) {
        return _this2.initPlugin(plugin);
      });
      pluginsToInit = [];
    }
  }, {
    key: "initPlugin",
    value: function initPlugin(plugin) {
      var pluginLogger = _Logger.default.namespace("Plugin ".concat(plugin.name));

      try {
        plugin.fn(this, pluginLogger);
        this.state.$emit('plugin.loaded', {
          name: plugin.name
        });
      } catch (err) {
        pluginLogger.error(err.stack);
      }
    }
    /**
     * Get a reference to an internal Kiwi module
     *
     * E.g. require('helpers/TextFormatting');
     * @param {String} mod The module path
     */

  }, {
    key: "require",
    value: function require(modPath) {
      var path = modPath.replace(/\//g, '.');

      var mod = _lodash.default.get(this.exports, path);

      if (typeof mod === 'undefined') {
        _Logger.default.error('Module does not exist: ' + modPath);
      }

      return mod;
    }
  }, {
    key: "setState",
    value: function setState(state) {
      var _this3 = this;

      this.state = state; // Hacky, but since Vues emitter doesnt support 'all', hijack its $emit call
      // so that we can forward the event on to plugins

      var stateEmit = this.state.$emit;
      var thisEmit = this.emit;

      this.state.$emit = function () {
        var _context3;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        try {
          var _context, _context2;

          thisEmit.call.apply(thisEmit, (0, _concat.default)(_context = [_this3, 'all', args[0]]).call(_context, (0, _toConsumableArray2.default)((0, _slice.default)(args).call(args, 1))));
          thisEmit.call.apply(thisEmit, (0, _concat.default)(_context2 = [_this3]).call(_context2, args));
        } catch (err) {
          _Logger.default.error(err.stack);
        }

        return stateEmit.call.apply(stateEmit, (0, _concat.default)(_context3 = [_this3.state]).call(_context3, args));
      }; // Let plugins emit events into the internal state


      this.emit = function () {
        var _context4, _context5;

        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        stateEmit.call.apply(stateEmit, (0, _concat.default)(_context4 = [_this3.state]).call(_context4, args));
        thisEmit.call.apply(thisEmit, (0, _concat.default)(_context5 = [_this3]).call(_context5, args));
      };
    }
  }, {
    key: "setThemeManager",
    value: function setThemeManager(themeManager) {
      this.themes = themeManager;
    }
    /**
     * Change the logging level output
     * @param {number} newLevel The new logging level
     */

  }, {
    key: "logLevel",
    value: function logLevel(newLevel) {
      _Logger.default.setLevel(newLevel);
    }
  }, {
    key: "log",
    get: function get() {
      return _Logger.default;
    }
    /**
     * Add a DOM element to different parts of the Kiwi UI
     * - addUi('input', domElement)
     * - addUi('browser', domElement)
     * - addUi('header_channel', domElement)
     * - addUi('header_query', domElement)
     * - addUi('userbox_button', domElement)
     * - addUi('about_buffer', domElement)
     * @param {string} type Where this DOM element should be added
     * @param {element} element The HTML element to add
     * @param {object} args Optional arguments for this plugin
     */

  }, {
    key: "addUi",
    value: function addUi(type, element) {
      var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var plugin = {
        el: element,
        id: nextPluginId++,
        args: args
      };

      switch (type) {
        case 'input':
          this.controlInputPlugins.push(plugin);
          break;

        case 'browser':
          this.stateBrowserPlugins.push(plugin);
          break;

        case 'header_channel':
          this.channelHeaderPlugins.push(plugin);
          break;

        case 'header_query':
          this.queryHeaderPlugins.push(plugin);
          break;

        case 'userbox_button':
          this.userboxButtonPlugins.push(plugin);
          break;

        case 'about_buffer':
          this.aboutBufferPlugins.push(plugin);
          break;

        default:
          break;
      }
    }
    /**
     * Add a Vue component as a tab to different tabbed views in the Kiwi API
     * - addTab('channel', 'title', component, props)
     * - addTab('settings', 'title', component, props)
     * - addTab('server', 'title', component, props)
     * @param {String} type The type of tab to add. This determines where it will be shown
     * @param {String} title The title shown on the tab
     * @param {Component} component The vuejs component that is displayed for this tab
     * @param {Object} props Optional properties for the vuejs component
     */

  }, {
    key: "addTab",
    value: function addTab(type, title, component, props) {
      var plugin = {
        id: nextPluginId++,
        title: title,
        component: component,
        props: props
      };

      switch (type) {
        case 'channel':
          this.sideBarPlugins.push(plugin);
          break;

        case 'settings':
          this.appSettingsPlugins.push(plugin);
          break;

        case 'server':
          this.serverViewPlugins.push(plugin);
          break;

        default:
          break;
      }
    }
    /**
     * Register a Vue component that may be shown in future. It is shown over the entire
     * client alongside the StateBrowser
     * @param {String} name A name to reference this view in future
     * @param {Component} component The vuejs component to create the view
     * @param {Object} props Optional properties the the vuejs component
     */

  }, {
    key: "addView",
    value: function addView(name, component, props) {
      this.tabs[name] = {
        id: nextPluginId++,
        component: _vue.default.extend(component),
        props: props || {}
      };
    }
    /**
     * Show a previously registered view
     * @param {String} name The name of previously registered view to show
     */

  }, {
    key: "showView",
    value: function showView(name) {
      // null disables any active component and reverts the UI back to the buffers
      var tab = this.tabs[name];

      if (tab) {
        this.state.$emit('active.component', tab.component, tab.props);
      } else {
        this.state.$emit('active.component', null);
      }
    }
    /**
     * Show a Vuejs component in the sidebar
     * @param {Object} component The vuejs component to render
     * @param {Object} props Optional properties for the vuejs component
     */

  }, {
    key: "showInSidebar",
    value: function showInSidebar(component, props) {
      this.state.$emit('sidebar.component', component, props);
    }
    /**
     * Add a custom startup screen that may be loaded by the configuration file
     * @param {String} name The name of this startup screen
     * @param {Object} ctor The constructor object for the vuejs component
     */

  }, {
    key: "addStartup",
    value: function addStartup(name, ctor) {
      var startups = this.state.getStartups();
      startups[name] = ctor;
    }
    /**
     *
     * @param {String} dest The module path to replace
     * @param {Object} source The new module to insert in place
     */

  }, {
    key: "replaceModule",
    value: function replaceModule(dest, source) {
      var mod = this.require(dest);

      if (!mod) {
        throw new Error("The module ".concat(dest, " does not exist"));
      }

      Misc.replaceObjectProps(mod, source);
    }
  }], [{
    key: "singleton",
    value: function singleton() {
      singletonInstance = singletonInstance || new GlobalApi();
      return singletonInstance;
    }
  }]);
  return GlobalApi;
}(_eventemitter.default);

exports.default = GlobalApi;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["GlobalApi"]
window._kiwi_exports.libs.GlobalApi = exports.default ? exports.default : exports;
